<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTab.value"
    height="100%"
    @tab-click="tabClick"
  >
    <LeftRightBox
      height="100%"
      :leftWidthDefault="450"
      style="margin-bottom: 10px"
    >
      <template slot="left">
        <SimpleTable
          :showIndex="false"
          ref="gclqdLeft"
          table-code="gclqdLeft"
          :menus="['查询', '批量修改']"
          :columns="currentTab.columnsLeft"
          :data="tableData.left"
          :loading="loading.left"
          @row-select="onRowSelect"
        />
      </template>
      <template slot="right">
        <SimpleTable
          ref="gclqdRight"
          table-code="gclqdRight"
          :showIndex="false"
          :menus="['查询', '批量修改']"
          :columns="currentTab.columnsRight"
          :data="tableData.right"
          :loading="loading.right"
          @row-select="onRowSelectRight"
          @modify-data-change="onModifyData"
        />
      </template>
    </LeftRightBox>
  </TabBtn>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import {
  sortRecords,
  getOptions,
  addCbFn,
  initCalculation
} from '@/utils/index'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'

const canEdit = {
  canEdit: true,
  canModify: true
}
const canModify = {
  canModify: true
}

export default {
  name: 'Gclqd',
  inject: ['detailsVm'],
  components: {
    SimpleTable,
    TabBtn,
    LeftRightBox
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    },
    importRecordId: {
      type: String,
      default: ''
    },
    tabsCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabs: [
        {
          label: '指标分类',
          value: 'constructionCostBudgetBottom_zbfl',
          columnsLeft: [{ field: 'name', title: '指标分类', tree: true }],
          columnsRight: [
            { field: 'code', title: '编码' },
            { field: 'projectName', title: '项目名称' },
            { field: 'projectDesc', title: '项目特征' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '工程量' },
            { field: 'rate', title: '单价', fieldType: 'number', ...canEdit },
            {
              field: 'amount',
              title: '合价',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              )
            },
            {
              field: 'adjustCoefficient',
              title: '调价系数',
              fieldType: 'number',
              ...canEdit
            },
            {
              field: 'adjustAmount',
              title: '调整后金额',
              fieldType: 'number',
              calculation: initCalculation(
                ['amount', 'adjustCoefficient', 'rate'],
                'amount * adjustCoefficient'
              )
            },
            { field: 'itemCount', title: '子目数' },
            { field: 'constructionGroupName', title: '施工班组' },
            {
              field: 'subcontractModel',
              title: '分包模式',
              ...canEdit,
              ...getOptions({
                title: '预算类型',
                key: 'subcontractModel',
                options: [{ name: '包干' }, { name: '包活' }]
              })
            }
          ],
          urlLeft: {
            constructionCostBudgetBottom_fbfx:
              '/project-unit-budget/new-bq-item/indicator-category-tree/list',
            constructionCostBudgetBottom_csxm:
              '/project-unit-budget/new-measure-item/indicator-category-tree/list'
          },
          urlRight: {
            constructionCostBudgetBottom_fbfx:
              '/project-unit-budget/new-bq-item',
            constructionCostBudgetBottom_csxm:
              '/project-unit-budget/new-measure-item'
          }
        },
        {
          label: '施工班组',
          value: 'constructionCostBudgetBottom_sgbz',
          columnsLeft: [{ field: 'name', title: '施工班组', tree: true }],
          columnsRight: [
            { field: 'code', title: '编码' },
            { field: 'projectName', title: '项目名称' },
            { field: 'projectDesc', title: '项目特征' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '工程量' },
            { field: 'rate', title: '单价', fieldType: 'number', ...canEdit },
            {
              field: 'amount',
              title: '合价',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              )
            },
            {
              field: 'adjustCoefficient',
              title: '调价系数',
              fieldType: 'number',
              ...canEdit
            },
            {
              field: 'adjustAmount',
              title: '调整后金额',
              fieldType: 'number',
              calculation: initCalculation(
                ['amount', 'adjustCoefficient', 'rate'],
                'amount * adjustCoefficient'
              )
            },
            { field: 'itemCount', title: '子目数' },
            { field: 'constructionGroupName', title: '施工班组' },
            {
              field: 'subcontractModel',
              title: '分包模式',
              ...canEdit,
              ...getOptions({
                title: '预算类型',
                key: 'type',
                options: [{ name: '包干' }, { name: '包活' }]
              })
            }
          ],
          urlLeft: {
            constructionCostBudgetBottom_fbfx:
              '/project-unit-budget/new-bq-item/construction-group-tree/list',
            constructionCostBudgetBottom_csxm:
              '/project-unit-budget/new-measure-item/construction-group-tree/list'
          },
          urlRight: {
            constructionCostBudgetBottom_fbfx:
              '/project-unit-budget/new-bq-item',
            constructionCostBudgetBottom_csxm:
              '/project-unit-budget/new-measure-item'
          }
        }
      ],

      currentTab: {},
      loading: {
        left: false,
        right: false
      },
      tableData: {
        left: [],
        right: []
      }
    }
  },
  watch: {
    tabsCode() {
      this.getTableDataLeft()
    },
    basicInfo() {
      this.init()
    },
    importRecordId() {
      this.getTableDataLeft()
    }
  },
  created() {
    this.currentTab = this.tabs[0]
    this.init()
  },
  methods: {
    init() {
      if (!this.basicInfo?.id || !this.importRecordId) return
      this.tabClick(this.tabs[0])
    },

    tabClick(tab) {
      this.currentTab = tab
      this.getTableDataLeft()
    },
    async getTableDataLeft() {
      this.tableData.left = []
      this.tableData.right = []
      this.loading.left = true
      const res = await this.$service.get(
        this.currentTab.urlLeft[this.tabsCode],
        {
          budgetId: this.basicInfo.id,
          importRecordId: this.importRecordId
        }
      )
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.gclqdLeft.initialized()
    },

    onRowSelect(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTableDataRight(obj)
    },

    async getTableDataRight(obj) {
      this.tableData.right = []
      if (obj?.id === undefined) return
      this.loading.right = true
      const res = await this.$service.get(
        this.currentTab.urlRight[this.tabsCode] + '/list',
        {
          budgetId: this.basicInfo.id,
          importRecordId: this.importRecordId,
          indicatorId:
            this.currentTab.value === 'constructionCostBudgetBottom_zbfl'
              ? obj.id
              : undefined,
          constructionGroupId:
            this.currentTab.value === 'constructionCostBudgetBottom_sgbz'
              ? obj.id
              : undefined
        }
      )
      this.loading.right = false
      this.tableData.right = sortRecords(res.data || [])
      this.$refs.gclqdRight.initialized()
    },

    onRowSelectRight(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.$emit('setBillId', obj.id)
    },

    async onModifyData(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        this.currentTab.urlRight[this.tabsCode] + '/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            importRecordId: this.importRecordId,
            budgetId: this.basicInfo.id
          }))
      )
    }
  }
}
</script>

<style scoped lang="less">
.label-content {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .content {
    width: 100%;
    flex: 1;
  }
}
</style>
